const highlightedAlpha = 0.1
const defaultAlpha = 0.15

export { highlightedAlpha, defaultAlpha }
